import { useEffect, useState } from "react";
import { SubmitButton } from "../../components/Input";
import StateManagedSelect from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const incentiveOption = [
  {
    value: "0",
    label: "Percentage",
  },
  {
    value: "1",
    label: "Fixed",
  },
];

const IncentiveRuleForm = () => {
  const [minTarget, setMinTarget] = useState("");
  const [maxTarget, setMaxTarget] = useState("");
  const [value, setvalue] = useState("");
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedIncentiveType, setSelectedIncentiveType] = useState(null);

  const fetchIncentiveRule = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/incentiverule/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response.data.data;

      setMinTarget(data.min_target);
      setMaxTarget(data.max_target);
      setvalue(data.value);
      setSelectedIncentiveType(
        incentiveOption.find((opt) => opt.value === data.incentive_type)
      );
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchIncentiveRule();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!minTarget || !maxTarget || !value || !selectedIncentiveType) {
      showToast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      const url = id
        ? `${API_URL}settings/incentiverule/save?id=${id}`
        : `${API_URL}settings/incentiverule/save`;

      const payload = {
        min_target: Number(minTarget),
        max_target: Number(maxTarget),
        incentive_type: selectedIncentiveType.value,
        value: Number(value),
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(url, payload, config);

      if (response.data.success) {
        showToast.success(response.data.message);
        navigate("/Settings/IncentiveRule");
      } else {
        showToast.error(response.data.message || "Failed to save data");
      }
    } catch (error) {
      console.error("Submit Error:", error);
      showToast.error(error.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <div className="panel-heading border-0">
        <span className="panel-title">
          {id ? "Edit " : "Add "} Incentive Rule Form
        </span>
      </div>
      <div className="panel-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="row">
              <div className="col-md-4 mb-2">
                <label className="control-label">Min Target</label>
                <input
                  type="number"
                  className="form-control"
                  value={minTarget}
                  onChange={(e) => setMinTarget(e.target.value)}
                  placeholder="Enter Min Target"
                  required
                />
              </div>
              <div className="col-md-4 mb-2">
                <label className="control-label">Max Target</label>
                <input
                  type="number"
                  className="form-control"
                  value={maxTarget}
                  onChange={(e) => setMaxTarget(e.target.value)}
                  placeholder="Enter Max Target"
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 mb-2">
                <label className="control-label">Value</label>
                <input
                  type="number"
                  className="form-control"
                  value={value}
                  onChange={(e) => setvalue(e.target.value)}
                  placeholder="Enter Value"
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">Incentive Type</label>
                <StateManagedSelect
                  options={incentiveOption}
                  value={selectedIncentiveType}
                  onChange={(select) => setSelectedIncentiveType(select)}
                  placeholder="Select Incentive Type"
                  isClearable={false}
                />
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <SubmitButton
                pageBack={"/Settings/IncentiveRule"}
                handleSubmit={handleSubmit}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IncentiveRuleForm;
